<template>
   <div class="halfwidth-yellow1" style="background: #49494a;">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="282.6px"
	 height="57.6px" viewBox="0 0 282.6 57.6" style="overflow:visible;enable-background:new 0 0 282.6 57.6;" xml:space="preserve">

<defs>
</defs>
<g id="Layer_2_2_">
	<g id="Layer_1-2_1_">
		<path class="st0-street" d="M167.8,13.7L167.8,13.7L167.8,13.7c-0.1-7.3-6-13-13.2-13c-2.7,0-5.2,0.8-7.4,2.3V3c-0.4-1.7-2-2.9-3.8-2.9
			c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0,7.5l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6l0-15.4l0-0.2c0.2-4,3.4-7.1,7.4-7.2
			c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0,17.5l1.8,1.5c2,0,3.7-1.6,3.9-3.6V14.1l0-0.2L167.8,13.7"/>
		<path class="st0-street" d="M261.8,13.7L261.8,13.7L261.8,13.7c-0.1-7.3-6-13-13.2-13c-2.7,0-5.2,0.8-7.4,2.3V2.9c-0.4-1.7-2-2.9-3.8-2.9
			c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0,7.5l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6l0-15.4l0-0.2c0.2-4,3.4-7.1,7.4-7.2
			c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0,17.5l1.8,1.5c2,0,3.7-1.6,3.9-3.6l0-15.1l0-0.2L261.8,13.7"/>
		<path class="st0-street" d="M82.9,32.8l-14.6,0c-4.8,0-9.5-3.2-12.3-7c-1.9-2.7-2.9-5.9-2.8-9.1c0-8.8,7.2-16,16-16c3.3,0,6.5,1,9.2,2.8
			c1.1-2.4,3.8-3.4,6.2-2.3c1.7,0.7,2.7,2.4,2.8,4.2l-2.3,2.5l0,17.6l2.3,2.8C87.4,30.6,85.4,32.7,82.9,32.8 M79.6,13.1
			C77,9.2,74.3,6.2,69.2,6.2c-5.8,0-10.5,4.7-10.4,10.5c0,5.7,4.6,10.3,10.3,10.4l10.4,0V13.1z"/>
		<path class="st0-street" d="M200.6,15.7c-0.7-5.9-4.8-10.8-10.5-12.6c-0.6-2-2.6-3.3-4.6-3l-2.3,2.4c-7.5,1-13.1,7.5-13.1,15
			c0,1,0.1,2,0.3,3c0.7,3.7,2.8,7.1,5.9,9.3c1.1,0.8,2.3,1.5,3.6,2l0.3,0.1l0.7,0.2c5.4,1.7,11.3,0.3,15.3-3.7
			C199.6,25.1,201.2,20.4,200.6,15.7 M175.6,17.5c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8c0,5.4-4.4,9.8-9.8,9.8
			C180,27.4,175.6,23,175.6,17.5C175.6,17.5,175.6,17.5,175.6,17.5"/>
		<path class="st0-street" d="M233.2,15.7c-0.7-5.9-4.8-10.8-10.5-12.6c-0.6-2-2.6-3.3-4.6-3l-2.3,2.4c-7.5,1-13,7.4-13,15c0,1,0.1,2,0.3,3
			c0.3,1.4,0.8,2.8,1.4,4.2c1.1,2.1,2.6,3.8,4.5,5.2c1.1,0.8,2.3,1.5,3.6,2l0.3,0.1l0.7,0.2c5.4,1.7,11.3,0.3,15.3-3.7
			C232.2,25.1,233.8,20.4,233.2,15.7 M208.2,17.6c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8c0,5.4-4.4,9.8-9.8,9.8
			C212.6,27.4,208.2,23,208.2,17.6C208.2,17.6,208.2,17.6,208.2,17.6"/>
		<path class="st0-street" d="M138.6,13.6L138.6,13.6L138.6,13.6c-0.1-7.2-6-12.5-13.2-12.9c-4,0-7.9,1.8-10.4,4.9
			c-2.5-3.1-6.3-4.9-10.3-4.9c-2.7,0-5.2,0.8-7.4,2.3V3c-0.4-1.7-2-2.9-3.8-2.9c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0,25.1l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6V13.8c0-4.1,3.3-7.4,7.4-7.4c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0.1,17.5l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6V25V13.8c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.2,7.5,7.2l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6L138.6,13.6
			L138.6,13.6z"/>
		<path class="st0-street" d="M50,13.6L50,13.6L50,13.6C49.9,6.4,44,1.1,36.8,0.7c-4,0-7.9,1.8-10.4,4.9c-2.5-3.1-6.3-5-10.3-5
			c-2.7,0-5.2,0.8-7.4,2.3l0-0.1C8.3,1.2,6.8,0,5,0C2.9,0,1.1,1.7,1.1,3.8l2,2.3l0,25.2l1.8,1.5c2,0,3.7-1.6,3.9-3.6l0-15.4
			c0-4.1,3.3-7.4,7.4-7.4c4.1-0.1,7.4,3.1,7.5,7.2c0,0.1,0,0.1,0,0.2l0.1,17.5l1.8,1.5c2,0,3.7-1.6,3.9-3.6V25V13.8
			c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.2,7.5,7.2l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6L50,13.6L50,13.6z"/>
		<path class="st1-street" d="M166.8,13.7L166.8,13.7L166.8,13.7c-0.1-7.3-6-13-13.2-13c-2.7,0-5.2,0.8-7.4,2.3V2.9c-0.4-1.7-2-2.9-3.8-2.9
			c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0,7.5l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6V13.8l0-0.2c0.2-4,3.4-7.1,7.4-7.2
			c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0,17.5l1.8,1.5c2,0,3.7-1.6,3.9-3.6l-0.1-15.1l0-0.2L166.8,13.7"/>
		<path class="st1-street" d="M260.8,13.7L260.8,13.7L260.8,13.7c-0.1-7.3-6-13-13.2-13c-2.7,0-5.2,0.8-7.4,2.3V2.9c-0.4-1.7-2-2.9-3.8-2.9
			c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0,7.5l0,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6l0-15.4l0-0.2c0.2-4,3.4-7.1,7.4-7.2
			c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0,17.5l1.8,1.5c2,0,3.7-1.6,3.9-3.6V14.1l0-0.2L260.8,13.7"/>
		<path class="st1-street" d="M81.9,32.8l-14.6,0c-4.8,0-9.5-3.2-12.3-7c-1.9-2.7-2.9-5.9-2.8-9.1c0-8.8,7.2-16,16-16c3.3,0,6.5,1,9.2,2.7
			c1.1-2.4,3.8-3.4,6.2-2.3c1.7,0.7,2.7,2.4,2.8,4.2l-2.3,2.4v17.6l2.3,2.8C86.3,30.6,84.4,32.6,81.9,32.8 M78.5,13.2
			C76,9.2,73.3,6.3,68.2,6.3c-5.8,0-10.5,4.7-10.4,10.5c0,5.7,4.6,10.3,10.3,10.4l10.4,0L78.5,13.2z"/>
		<path class="st1-street" d="M199.5,15.7c-0.7-5.9-4.8-10.8-10.4-12.6c-0.6-2-2.6-3.3-4.6-3l-2.3,2.4c-7.5,1-13.1,7.4-13.1,15
			c0,1,0.1,2,0.3,3c0.7,3.7,2.8,7.1,5.9,9.3c1.1,0.8,2.3,1.5,3.6,2l0.3,0.1l0.7,0.2c5.4,1.7,11.3,0.2,15.3-3.8
			C198.5,25.1,200.1,20.4,199.5,15.7 M174.5,17.6c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8c0,5.4-4.4,9.8-9.8,9.8
			C178.9,27.4,174.5,23,174.5,17.6C174.5,17.6,174.5,17.6,174.5,17.6"/>
		<path class="st1-street" d="M232.1,15.7c-0.5-4.4-3-8.3-6.6-10.8c-1.2-0.8-2.5-1.4-3.8-1.8c-0.6-2-2.6-3.3-4.6-3l-2.3,2.4
			c-7.5,1-13.1,7.4-13.1,15c0,1,0.1,2,0.3,3c1,5.1,4.6,9.4,9.5,11.3l0.3,0.1l0.7,0.2c5.4,1.7,11.3,0.3,15.3-3.7
			C231.1,25.1,232.7,20.4,232.1,15.7 M207.1,17.6c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8c0,5.4-4.4,9.8-9.8,9.8
			C211.5,27.4,207.1,23,207.1,17.6C207.1,17.6,207.1,17.6,207.1,17.6"/>
		<path class="st1-street" d="M137.6,13.7L137.6,13.7L137.6,13.7c-0.1-7.2-6-12.5-13.2-12.9c-4,0-7.9,1.8-10.4,4.9
			c-2.5-3.1-6.3-4.9-10.3-4.9c-2.7,0-5.2,0.8-7.4,2.3V3c-0.4-1.7-2-2.9-3.8-2.9c-2.1,0-3.8,1.7-3.9,3.8l2,2.3l0.1,25.1l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6V13.8c0-4.1,3.3-7.4,7.4-7.4c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0.1,17.5l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6v-4.2V13.8c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.2,7.5,7.2l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6L137.6,13.7
			L137.6,13.7z"/>
		<path class="st1-street" d="M49,13.7L49,13.7L49,13.7C48.8,6.5,43,1.2,35.8,0.8c-4-0.1-7.9,1.7-10.4,4.9c-2.5-3.1-6.3-4.9-10.3-4.9
			c-2.7,0-5.2,0.8-7.4,2.3l0-0.1C7.5,2.2,7.1,1.6,6.6,1.1C5-0.4,2.5-0.3,1,1.3C0.4,2,0,2.9,0,3.9l2,2.3L2,31.4l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6l0-15.4c0-4.1,3.3-7.4,7.4-7.4c4.1-0.1,7.5,3.1,7.6,7.2c0,0.1,0,0.1,0,0.2l0.1,17.5l1.8,1.5
			c2,0,3.7-1.6,3.9-3.6V25V13.8c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.2,7.5,7.3l0.1,17.7l1.8,1.5c2,0,3.7-1.6,3.9-3.6L49,13.7L49,13.7
			z"/> 
		<path class="st3-street" d="M212.9,40.8c-1.4,0.8-2.8,1.6-4.1,2.5c2.2,0.8,9.1,6.3,8.8,8.3c-0.3,0.4-1,0.5-1.4,0.1
			c-2-3.3-6.9-5.5-10.7-6.4c-0.9,1.8-0.8,6-1.1,8.3c-0.6,0.2-1.2,0-1.7-0.4c-1.4-3.8-0.1-8.4,1.1-11.8c0.8-2.6,1.9-5.1,3.2-7.5
			c0.7-1.3,1.4-2.6,1.6-2.9c-1.6,0-3.3,0.1-4.9,0.2c-4.1,7.7-7.8,15.5-9.4,25.2c-2.4,0-2.3-2.9-2-4.4c0.3-2.3,0.9-4.6,1.7-6.8
			c1.5-4.6,3.3-9.1,5.6-13.3c-3.6,0.6-6.8,1.8-9.4,2.4c-0.3,0-0.6-0.3-0.8-0.5c0.5,2.6-2.4,8.9-5.9,12c-0.5,0.5-1,0.9-1.5,1.3
			c-1.2,0.3-2.4-0.4-2.7-1.6c-0.1-0.4-0.1-0.8,0-1.2c3.7-3.5,6.3-6.5,6.8-11.8c-0.5-0.5-1.8-0.2-2.3-0.1c-5,1.1-10.1,4.8-13.4,7.9
			c-1.8,1.7-3.3,3.1-3.5,5.5c1.8,1.3,4,1.5,6.8,1.7c3.3,0.1,6.7,0.5,10,1.1c1,0.1,2.1,0.5,2.9,1.1c1,0.7,3,2.3,1.8,3.9
			c-1.3,1.5-6.2,3.2-9.6,3.7c-6,0.9-12.4,0-12.6-4.7c0.1-0.4,2.5-1.2,3.2-0.7c-0.1,0.8-1.1,1.3-1.1,1.9c0.7,0.7,1.5,1.2,2.5,1.4
			c2.4,0.6,5,0.6,7.4,0c0.7-0.2,1.4-0.4,2-0.6c2.1-0.7,4-1.7,5.8-3c-4.3-1.9-13.4-0.6-18.4-2.4c-1.5-0.5-3.2-2.9-3.2-5.3
			c0-2.5,1.3-3.7,3.2-5.3c1.2-1,2.8-2.3,4.2-3.3c3-2.1,6.9-4.6,10.9-5.5c0.6-0.1,1.1-0.2,1.7-0.3c1.9,0.9,3.3,1.5,4.6,3.3
			c0.3-0.2,0.6-0.4,0.9-0.5c5.8-3,12.3-4.5,18.8-4.6c0.8,0.2,1.4,0.9,1.7,1.7c0.9-0.3,4.2-1.2,4.9-1.4c3.7-0.7,6.9-0.1,8.8,1.6
			c0.8,0.8,1.7,2.4,1.2,3.5c0.6-0.8,1-1.6,1.6-2.5c0.2-0.4,0.3-0.5,0.6-1.1c-0.5,0-1.5,0.4-2,0.4c-0.7-0.5-1-1.2-1.1-2
			c1.8,0.1,6.7-1.3,7.3-1.5c3.2-0.9,6.5-1.4,9.8-1.7c1.1,0,1.1,1.2,1.4,1.7c0.6-0.2,4.6-1.5,5.6-1.8c2.4-0.6,8.5-2.2,11.2-1.9
			c0.7,0.4,1.1,2.1,2,2.5c-0.1,0.6,0.2,0.7-0.1,1.2c-4.8,0.3-8.7,0.3-13.6,1.2c-2.2,3.5-4.2,7.2-5.9,11c0.6-0.4,6.1-1.5,12.3-2.4
			c0.4-0.1,0.2,0.4,0.4,0.7c0.7,0.8,2.1,0.9,1.5,2.7c-3.7,0.2-8.4,0.9-12.4,1.3c-0.7,0.1-2.4,0.2-3,0.3c-0.7,1.8-1.3,3.7-1.7,5.6
			c3.6-0.5,10.1-0.8,13.4-1.5c0.9-0.1,1.9,0.3,2.4,1.1c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.2,0.3-0.4,0.4c-5,0.4-16.1,1.1-18.9,1.4
			c-0.3-1.9-0.5-2,0.1-2.1c0.2,0,0.5,0,0.5-0.3c0.4-1.4,1.3-4.3,1.7-5.7c0,0-0.1,0.3-0.3,0.3c-3.5,0-9.8,1.5-14.4,2.2
			c-0.5,1.6-0.9,3.2-1.2,4.8c2.3-0.5,8.6-1.6,10.1-1.9c0.5-0.1,2.3,1.2,2.7,1.8c0.2,0.4,0.1,0.9-0.1,1.3c-5.4,0-10.8,0.5-16.2,1.5
			c-0.5-1.2-0.5-1.1-0.8-1.9c0.4-0.1,1.3-0.3,1.6-0.4c0-1.6,0.2-3.2,0.5-4.8c-1.1,0.2-1-1-1.1-1.6c0.8-0.3,1.6-0.5,1.6-0.5
			s1.9-4.6,3.7-8C220.9,36.6,213.2,40.6,212.9,40.8z M238.9,38.8c1.4-3.8,3.2-7.4,5.4-10.7c-0.9,0.2-1.8,0.4-2.6,0.7
			c0-0.4,0-0.5,0-0.8c-3.8-0.3-7.6,0-11.3,0.8c-2.5,3.9-4.7,8.1-6.3,12.4c3.5-1.1,7.1-2,10.8-2.7c1.1-0.2,2.2-0.5,2.8,1.4
			C238,38.4,238.8,39.2,238.9,38.8L238.9,38.8z M219.2,33.5c1.2-0.5,2.1-1.5,2.6-2.6c-0.8-0.2-1.6-0.2-2.3-0.2
			c-2.4,0-4.8,0.4-7.1,1.1c-1.3,2.5-3.8,6.3-5,8.8C210.5,39,218.7,33.9,219.2,33.5z"/>
		<path class="st3-street" d="M259.3,41.1c2.7-6.1,8.8-14.7,9.5-16c0.2-0.1-5.6,1.1-8.5,2c-0.4-1-0.2-0.8-0.7-2.2
			c8.3-3.2,19.1-5.6,20.5-4.9c0.8,0.3,3.1,1.5,2.3,4c-2.1-0.1-7.3,0.1-8.9,0.6c-2.9,2.7-11.2,15.8-12.7,19.8
			c-0.6,1.5-1.1,3.1-1.4,4.7c-2.4,0.1-1.9-3.2-1.6-3.8C258.2,43.9,258.7,42.5,259.3,41.1z"/>
	</g>
</g>
</svg>
  </div>
</template>









<script>
export default {
  name: "mamnoonstreet1",
  data() {
    return {
	//   link: "https://www.trycaviar.com/m/mamnoon-street-6597"
	  link: "https://app.upserve.com/s/mamnoon-street-seattle"
    };
  },
  props: ["linkOut","caviarLink"],
  
  methods: {
    openLink(e) {
      window.open(e, "_blank");
      console.log(e);
    },
    open(e){
		if(this.caviarLink){
      window.open("https://app.upserve.com/s/mamnoon-street-seattle", "_blank");
		}else{
      document.getElementById(e).click();
		}

    }
  }
};
</script>

        <style lang="scss">
.cls-178 {
  fill: #49494a;
}

.halfwidth-yellow1 {
  height: 150px;
  width: 50%;
    width: 33.33%;
  display: inline-block;
  background: #fff367;
//   float: left;
  text-align: center;
      cursor: pointer;
	  position: relative;
  svg {
	  position: absolute;
	  left: 50%;
	  top: 50%;
	  transform: translate(-50%,-50%);
    width: 40%;
    text-align: center;
  }
}


@media only screen and (max-width: 768px) {
.halfwidth-yellow1 {
    height: 100px;
  width: 50%;
    width: 100%;
  display: inline-block;
  background: #fff367;
//   float: left;
  text-align: center;
      cursor: pointer;
	  position: relative;
  svg {
	  position: absolute;
	  left: 50%;
	  top: 50%;
	  transform: translate(-50%,-50%);
    width: 40%;
    text-align: center;
  }
}

}



	.st0-street{fill:#DF5857;
	
	fill: transparent;
	}
	.st1-street{
		fill:#231F20;
		fill: #ffffff;
		}

	.st2-street{fill-rule:evenodd;clip-rule:evenodd;}
	.st3-street{fill-rule:evenodd;clip-rule:evenodd;fill:#DF5857;}


</style>